import { useGetPayoutRequestSource } from "@fp/admin-api-client/payout-requests/payout-requests.client";
import { PageLoading } from "@fp/ui/components/base/page-layout/page-layout";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { AdminLayout } from "@/components/admin-layout";
import { getPayoutRequestRoute } from "@/lib/payout-request-route";

export const Route = createFileRoute("/payout-requests/$id")({
  component: RouteComponent,
  pendingComponent: () => <PageLoading />,
});

/**
 * A payout request is reviewed on the screen its workflow dictates, so anything that
 * holds only an id lands here and is forwarded once the source has been read.
 */
function RouteComponent() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { data, isError } = useGetPayoutRequestSource(id);

  const source = data?.data;

  useEffect(() => {
    if (source) {
      navigate({ ...getPayoutRequestRoute(id, source), replace: true });
    }
  }, [id, source, navigate]);

  useEffect(() => {
    if (isError) {
      navigate({ to: "/payout-requests", replace: true });
    }
  }, [isError, navigate]);

  return (
    <AdminLayout>
      <PageLoading />
    </AdminLayout>
  );
}